





















































































































import {
  createComponent,
  computed,
  ref,
  onMounted,
  onBeforeUnmount
} from '@vue/composition-api'
import { Vehicle, getAllVehicles, statusToString } from '~/models/vehicle'

export default createComponent({
  setup(_props, context) {
    const isLoading = ref<boolean>(false)
    const selectedVehicleId = ref<number>(0)
    const confirmMessage = ref<string>('')
    const showDialogVehicle = ref<boolean>(false)
    const usedVehicle = ref<boolean>(true)
    const doneVehicleDeselect = ref<Boolean>(false)
    const vehicles = ref<Vehicle[]>([])
    const vehicleLists = computed(() => {
      const values: any = []
      vehicles.value.forEach((v) => {
        const last_name = ref<string>('')
        const first_name = ref<string>('')
        if (v.current_driver) {
          const driver_name = v.current_driver.split(' ')
          last_name.value = driver_name[0]
          first_name.value = driver_name[1]
        }

        const vv = {
          id: v.id,
          name: v.name,
          license: v.license_plate,
          model: v.model,
          status: v.current_status,
          status_name: statusToString(v.current_status),
          driver_lastname: last_name.value,
          driver_firstname: first_name.value
        }
        values.push(vv)
      })
      values.sort((a: any, b: any) => {
        return a.value - b.value
      })
      return values
    })
    const vehicle_id = ref<number>(0)
    const showVehicleDeselect = (id: number) => {
      vehicle_id.value = id
    }
    const vehicleDeselect = () => {
      isLoading.value = true
      const selectVehicle = [
        {
          op: 'replace',
          path: '/is_selected',
          value: false
        },
        {
          op: 'replace',
          path: '/status_inactive',
          value: true
        }
      ]
      context.root.$axios
        .$patch(`/vehicles/${vehicle_id.value}`, selectVehicle)
        .then((response: any) => {
          // 画面上の表示更新
          const vehicle_id = response.id
          const current_driver = response.current_driver
          const current_status = response.current_status
          vehicles.value
            .filter((v) => v.id === vehicle_id)
            .map((v: any) => {
              v.current_driver = current_driver
              v.current_status = current_status
            })
          context.root.$nuxt.$emit(
            'deselectVehicle',
            vehicle_id,
            current_driver,
            current_status
          )
        })
        .catch((error: any) => {
          clearAllInterval()
          context.root.$nuxt.$emit('NetworkError', error)
        })
        .finally(() => {
          doneVehicleDeselect.value = false
        })
      isLoading.value = false
    }
    const fetchVehicles = async () => {
      if (context.root.$auth.loggedIn) {
        const [resVehicles] = await Promise.all([
          getAllVehicles(context.root.$axios).catch((error: any) => {
            clearAllInterval()
            context.root.$nuxt.$emit('NetworkError', error)
          })
        ])
        vehicles.value = resVehicles || []
      }
    }
    const intervalFetchVehiclesID = ref(0)
    const intervalFetchVehicles = 5000
    const clearAllInterval = () => {
      clearInterval(intervalFetchVehiclesID.value)
    }

    onMounted(() => {
      intervalFetchVehiclesID.value = window.setInterval(async () => {
        await fetchVehicles()
      }, intervalFetchVehicles)
      fetchVehicles()
    })
    onBeforeUnmount(() => {
      clearAllInterval()
    })
    return {
      isLoading,
      vehicleLists,
      vehicles,
      selectedVehicleId,
      showDialogVehicle,
      confirmMessage,
      usedVehicle,
      vehicleDeselect,
      showVehicleDeselect,
      doneVehicleDeselect,
      clearAllInterval
    }
  },
  auth: false
})
